<template>
  <div class="app-redactor">
    <label class="app-redactor__label" :for="_uid" v-if="label">
      {{ label }}
    </label>
    <textarea ref="redactor" :name="name" :placeholder="placeholder" :value="value" />
  </div>
</template>

<script>
// import Redactor from "@/assets/plugins/redactor/redactor.js"
// require("@/assets/plugins/redactor/_langs/ru");
// import "@/assets/plugins/redactor-plugins/variable/variable";
import "@/assets/plugins/redactor/redactor.min.css";
import "@/assets/plugins/redactor-plugins/variable/variable.min.css";

export default {
  name:    "AppRedactor",
  props:   {
    label:        {
      default: "",
      type:    String,
    },
    value:        {
      default: null,
    },
    name:         {
      default: "",
      type:    String,
    },
    spellcheck:   {
      default: false,
      type:    Boolean,
    },
    placeholder:  {
      default: false,
      type:    [String, Boolean],
    },
    minHeight:    {
      default: false,
      type:    [String, Boolean],
    },
    maxHeight:    {
      default: false,
      type:    [String, Boolean],
    },
    maxWidth:     {
      default: "100%",
      type:    [String, Boolean],
    },
    saveButton:   {
      default: false,
      type:    Boolean,
    },
    cancelButton: {
      default: false,
      type:    Boolean,
    },
    buttons:      {
      default() { return ['format', 'bold', 'italic', 'underline'];},
      type: Array,
    },
    useVariables: {
      default: false,
      type:    Boolean,
    },
    variables:    {
      default() {return [];},
      type: Array,
    },
  },
  data() {
    return {
      config: {
        lang:        'ru',
        styles:      true,
        spellcheck:  this.spellcheck,
        placeholder: this.placeholder,
        grammarly:   false,
        minHeight:   this.minHeight,
        maxHeight:   this.maxHeight,
        maxWidth:    this.maxWidth,
        variables:   [],
        plugins:     [],
        imageFigure: false,
      },
    };
  },
  methods: {
    setAddButton() {
      let vm = this;
      $R.add('plugin', 'savebutton', {
        translations: {
          en: {
            "savebutton": "Save",
          },
          ru: {
            "savebutton": "Сохранить",
          },
        },
        init:         function ( app ) {
          this.app = app;
          this.lang = app.lang;
          this.toolbar = app.toolbar;
        },
        start:        function () {
          // create the button data
          var buttonData = {
            title: this.lang.get('savebutton'),
            api:   'plugin.savebutton.toggle',
          };

          // create the button
          var $button = this.toolbar.addButton('savebutton', buttonData);
        },
        toggle:       function () {
          this.app.source.rebuildStartedContent();
          vm.$emit('save', this.app.source.getCode());
        },
      });
    },
    setCancelButton() {
      let vm = this;
      $R.add('plugin', 'cancelbutton', {
        translations: {
          en: {
            "cancelbutton": "Cancel",
          },
          ru: {
            "cancelbutton": "Отменить",
          },
        },
        init:         function ( app ) {
          this.app = app;
          this.lang = app.lang;
          this.toolbar = app.toolbar;
        },
        start:        function () {
          // create the button data
          var buttonData = {
            title: this.lang.get('cancelbutton'),
            api:   'plugin.cancelbutton.toggle',
          };

          // create the button
          var $button = this.toolbar.addButton('cancelbutton', buttonData);
        },
        toggle:       function () {
          this.app.source.setCode(this.app.source.getStartedContent());
        },
      });
    },
    init() {
      import('@/assets/plugins/redactor/redactor.js')
        .then(() => Promise.all([
          import("@/assets/plugins/redactor/_langs/ru"),
          import("@/assets/plugins/redactor-plugins/variable/variable"),
        ]))
        .then(() => {

          const callbacks = {
            changed: ( html ) => {
              this.handleInput(html);
              return html;
            },
          };
          this.$set(this.config, 'callbacks', callbacks);

          this.config.buttons = this.buttons;

          if (this.useVariables) {
            this.config.plugins.push('variable');
            this.config.variables = this.variables;
          }

          if (this.saveButton) {
            this.setAddButton();
            this.config.plugins.push('savebutton');
          }

          if (this.cancelButton) {
            this.setCancelButton();
            this.config.plugins.push('cancelbutton');
          }

          const app = $R(this.$refs.redactor, this.config);
          this.redactor = app;
          this.$parent.redactor = app;
        });
    },
    destroy() {
      $R(this.$refs.redactor, 'destroy');
      this.redactor = null;
      this.$parent.redactor = null;
    },
    handleInput( val ) {
      this.$emit('input', val);
    },
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.destroy();
  },
  watch:   {
    value( newValue ) {
      if (this.redactor) {
        if (!this.redactor.editor.isFocus()) this.redactor.source.setCode(newValue);
      }
    },
    variables() {
      if (this.redactor) {
        if (this.redactor.plugin && this.redactor.plugin.variable) {
          this.redactor.plugin.variable.opts.variables = this.variables;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.app-redactor {
  &__label {
    color: rgba(var(--app-heading-color-light), 1);
    font-size: 14px;
    margin-bottom: 2px;
    display: block;
  }
}

.redactor-dropdown {
  z-index: 999999;
}

.redactor-box.redactor-styles-on {
  border: 1px solid #ced4da;
}

.redactor-focus.redactor-styles-on, .redactor-focus:focus.redactor-styles-on {
  border-color: rgba(var(--app-primary), 1) !important;
}

.redactor-air a:hover, .redactor-toolbar a:hover {
  background: rgba(var(--app-primary), 1) !important;
}

.redactor-styles {
  del {
    /*text-decoration: line-through!important;*/
  }
}

#redactor-overlay {
  z-index: 50000;
}

#redactor-modal {
  z-index: 50001;
}

.redactor-modal .redactor-close {
  top: 6px;
  right: 8px;
}

.redactor-modal-header {
  padding: 10px 15px;
}

.redactor-modal-body {
  padding: 30px 15px;
}

.redactor-component[data-redactor-type=variable],
.redactor-variables-list span {
  background: rgba(var(--app-primary), 1);
}
</style>
